export default __webpack_public_path__ + "static/media/openrice.5f5e1efb.jpg";